// extracted by mini-css-extract-plugin
var _1 = "CloseButton_closeButton__hB+f2";
export { _1 as "closeButton" }
